var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { OfficeAchievementFullSizeDto } from './office-achievement.full-size.dto.js';
export class OfficeAchievementGiftCodeFullSizeDto {
    id;
    createdAt;
    updatedAt;
    code;
    officeAchievement;
    officeAchievementId;
}
__decorate([
    IsUUID(),
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "code", void 0);
__decorate([
    Expose(),
    IsObject(),
    Type(() => OfficeAchievementFullSizeDto),
    __metadata("design:type", Object)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "officeAchievement", void 0);
__decorate([
    Expose(),
    IsString(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], OfficeAchievementGiftCodeFullSizeDto.prototype, "officeAchievementId", void 0);
//# sourceMappingURL=office-achievement-gift-code.full-size.dto.js.map